import { WebSocketChannelClient } from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/WebSocketChannelClient";

const FileWebSocketClient = new WebSocketChannelClient("file-channel");
export default FileWebSocketClient;
